import { BrokerAccountInputModel } from '../models/BrokerAccountInputModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

interface BrokerAccountInputState {
    BrokerAccountInput: BrokerAccountInputModel,
    selectedBrokerAccountId: string,
    BrokerAccountInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
}

const initialState: BrokerAccountInputState = {
    BrokerAccountInput: {
        id: "",
        contactId: "",
        micName: "",
        accountType: "",
        brokerId: 0,
        startedDate: "",
        remark: "",
        contactName: "",
        expiredDate: ""
    } as BrokerAccountInputModel,
    selectedBrokerAccountId: "",
    BrokerAccountInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
}

export const BrokerAccountInputSlice = createSlice({
    name: "BrokerAccountInput",
    initialState,
    reducers: {
        setBrokerAccountInputId: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.id = action.payload;
        },
        setBrokerAccountInput: (state, action: PayloadAction<BrokerAccountInputModel>) => {
            state.BrokerAccountInput = action.payload;
        },
        setContactId: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.contactId = action.payload;
        },
        setMicName: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.micName = action.payload;
        },
        setAccountType: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.accountType = action.payload;
        },
        setBrokerId: (state, action: PayloadAction<number>) => {
            state.BrokerAccountInput.brokerId = action.payload;
        },
        setStartedDate: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.startedDate = action.payload;
        },
        setRemark: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.remark = action.payload;
        },
        setExpiredDate: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.expiredDate = action.payload;
        },
        setContactName: (state, action: PayloadAction<string>) => {
            state.BrokerAccountInput.contactName = action.payload;
        },
        setSelectedBrokerAccountId: (state, action: PayloadAction<string>) => {
            state.selectedBrokerAccountId = action.payload;
        },
        setBrokerAccountInputExpand: (state, action: PayloadAction<boolean>) => {
            state.BrokerAccountInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetBrokerAccountInput: (state) => {
            state.BrokerAccountInput = initialState.BrokerAccountInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const BrokerAccountInputSelector = createSelector(
    (state: RootState) => state.brokerAccountInput,
    (data) => data
);

export const {
    setBrokerAccountInputId,
    setBrokerAccountInput,
    setMicName,
    setContactId,
    setAccountType,
    setBrokerId,
    setStartedDate,
    setRemark,
    setExpiredDate,
    setContactName,
    setSelectedBrokerAccountId,
    setBrokerAccountInputExpand,
    setTriggerFocusCompanyNameInput,
    resetBrokerAccountInput,
    setTriggerSave,
    setTriggerRefreshInput,
} = BrokerAccountInputSlice.actions;

export default BrokerAccountInputSlice.reducer;